export function getShowIsForThirdCompany(
    isForThirdCompany: boolean | null,
    isB2B: boolean,
    hideEpcPpa: boolean,
) {
    return isForThirdCompany !== null && !!isB2B && !hideEpcPpa;
}

export const isBoolean = (val) => 'boolean' === typeof val;

const RangeIdentifier = '$';
const zipLengthWitoutSeparator = 7;
/*
expectation that ranges starts end ends with $
eg '$100-1000', '100-2000$'
*/
export function joinRanges(excluded: string[]): string[] {
    if (!excluded.find((e) => e.includes(RangeIdentifier))) {
        return excluded;
    }

    const withOutRanges = excluded.filter((e) => !e.includes(RangeIdentifier));

    const ranges = excluded.filter((e) => e.includes(RangeIdentifier));

    if (ranges.length % 2 != 0) {
        console.error('Inccoret ranges length');
        return null;
    }

    let resultRanges = [];

    for (let i = 0; i < ranges.length; i += 2) {
        if (
            ranges[i + 1][ranges[i + 1].length - 1] !== RangeIdentifier ||
            ranges[i][0] !== RangeIdentifier
        ) {
            console.error('Inccorect ranges separator');
            return null;
        }

        const startRange = parseInt(
            ranges[i].replace(RangeIdentifier, '').replace('-', ''),
        );

        const endRange = parseInt(
            ranges[i + 1].replace(RangeIdentifier, '').replace('-', ''),
        );

        if (startRange > endRange) {
            console.error('End range bigger then start');
            return null;
        }

        const resultRange = range(startRange, endRange).map(toZipCodeFormat);

        resultRanges = resultRanges.concat(resultRange);
    }
    return resultRanges.concat(withOutRanges).sort();
}

const toZipCodeFormat = (inputNumber: number): string => {
    const res = inputNumber.toString().padStart(zipLengthWitoutSeparator, '0');
    return insertAtIndex(res, '-', 3);
};

const insertAtIndex = (str: string, substring: string, index: number) =>
    str.slice(0, index) + substring + str.slice(index);

const range = (start: number, end: number) =>
    Array.from(Array(end - start + 1).keys()).map((x) => x + start);
